import type { InitOptions } from "@segment/analytics-next";

export const SEGMENT_INIT_OPTIONS: InitOptions = {
  integrations: {
    "Segment.io": {
      deliveryStrategy: { config: { keepalive: true } },
    },
  },
};
